import { render, staticRenderFns } from "./ConfirmDeleteModal.vue?vue&type=template&id=515a88f4&scoped=true&"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=515a88f4&scoped=true&lang=css&"
import style1 from "./ConfirmDeleteModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a88f4",
  null
  
)

export default component.exports